define('plugin/invoice/controller/InvoicePaymentMethodController',['require','lib/controller/BaseController','plugin/invoice/collection/InvoicePaymentMethodCollection','plugin/invoice/view/InvoicePaymentMethodListView'],function (require) {

    var BaseController = require('lib/controller/BaseController');

    var InvoicePaymentMethodCollection = require('plugin/invoice/collection/InvoicePaymentMethodCollection');
    var InvoicePaymentMethodListView = require('plugin/invoice/view/InvoicePaymentMethodListView');

    /**
     * Invoice payment methods controller
     *
     * @class InvoicePaymentMethodController
     */
    return BaseController.extend({

        list: function () {
            var collection = new InvoicePaymentMethodCollection();

            this.listenTo(collection, 'sync', _.bind(function () {
                var listView = new InvoicePaymentMethodListView({
                    collection: collection
                });
                this.listenTo(listView, 'payment_method:delete', function (model) {
                    model.destroy();
                });

                this.getMainLayout().getContentRegion().show(listView);
            }, this));

            collection.fetch();
        }

    });

});
